import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "finance-expand" }

import { computed, ref } from "vue";
import BaseModal from "@/components/common/modal/BaseModal.vue";
import ProjectFinanceSection from "@/components/main/project-block-page/finance/ProjectFinanceSection.vue";
import ProjectFinanceSummary from "@/components/main/project-block-page/finance/ProjectFinanceSummary.vue";
import { projectPageStore } from "@/store/project-page";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectFinanceExpandModal',
  emits: ["changed"],
  setup(__props, { expose: __expose, emit: __emit }) {

const projectStore = projectPageStore()

const project = computed(() => projectStore.openedProject)

const emit = __emit

const $modal = ref<InstanceType<typeof BaseModal> | null>(null)

const onOpen = () => $modal.value?.onOpen()
const onClose = () => $modal.value?.onClose()

__expose({ onOpen, onClose })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    ref_key: "$modal",
    ref: $modal,
    title: _ctx.$t('finances')
  }, {
    "header-right": _withCtx(() => [
      _createVNode(ProjectFinanceSummary, { project: project.value }, null, 8, ["project"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ProjectFinanceSection, {
          project: project.value,
          "project-id": project.value?.Id ?? 0,
          "finance-access": project.value?.FinanceAccess,
          expanded: true,
          onChanged: _cache[0] || (_cache[0] = ($event: any) => (emit('changed')))
        }, null, 8, ["project", "project-id", "finance-access"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})